<template>
  <div class="wim-quote-component tva-row">
    <div class="wim-quote-container tva-col-xs-12 tva-col-sm-offset-1 tva-col-sm-6 tva-col-lg-offset-1 tva-col-lg-5">
      <div class="wim-quote-wrapper">
        <div class="wim-poligon"></div>
        <p class="wim-quote red">{{content.text}}</p>
      </div>
      <p class="wim-quote-shadow">{{content.text}}</p>
    </div>
    <div class="wim-video-container tva-col-xs-12 tva-col-sm-4">
      <video
        class="wim-lazy-video"
        :poster="`${baseUrl}images/${content.video}.jpg`" 
        controls
        style="position:absolute; width: calc(100% + 2px); top: 0; left:-1px; max-width: none;"
      >
        <source :data-src="`${baseUrl}images/${content.video}.mp4`" type="video/mp4">
      </video>
    </div>
  </div>
</template>
<script>
import LazyLoad from 'vanilla-lazyload'

export default {
  props: ["content"],
  mounted() {
    this.$nextTick(() => {
      var myLazyLoad = new LazyLoad({
          elements_selector: ".wim-lazy-video"
      });
    })
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";

.wim-quote-component {
  width: 100%;;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.wim-quote-container {
  position: relative;
  margin-top: 50px;
  margin-bottom: 50px;
  .wim-quote-shadow {
    margin:0;
    opacity: 0;
    width: 90%;
    text-align: left;
    text-justify: inter-word;
  }
  .wim-quote-wrapper {
    position:absolute;
    top:0;
    left:0;
    height: 100%;
    .wim-quote {
      margin:0;
      width: 100%;
      text-align: left;
      text-justify: inter-word;
    }
    .wim-polygon {
      display: none;
    }
    @supports (shape-outside: polygon(0 0, 19% 0, -2% 100%, 0 100%)) {
      .wim-quote {
        &::before {
          content: "";
          width: 0;
          height: 100%;
          border-right: 1px solid $black;
          transform: rotate(14deg);
          position: absolute;
          top: 0;
          left: 10%;
        }
      }
      .wim-poligon {
        -webkit-shape-outside: polygon(0 0, 19% 0, -2% 100%, 0 100%);
        shape-outside: polygon(0 0, 19% 0, -2% 100%, 0 100%);
        clip-path: polygon(0 0, 19% 0, -2% 100%, 0 100%);
        background:transparent;
        width: 100%;
        height: 500px;
        float:left;
      }
    }
     
  }
}
.wim-video-container {
  position: relative;
  overflow: hidden;
  padding-bottom: 18.75%;
  margin-left: 15px;
}

@media(max-width: 992px) {
  .wim-quote-component {
    display: block;
    border: solid 1px $red;
    border-right: 0;
    border-left: 0;
    padding: 10px 0;
    margin-left: 16.66666667%;
    width: calc(66.66666667% - 15px);
    margin-top: 20px;
    margin-bottom: 20px;
    .wim-quote-container {
      margin: 0 0 20px 0;
      padding:0;
      width: 100%;
      .wim-quote-shadow {
        display: none;
      }
      .wim-quote-wrapper {
        position: relative;
        display: block;
        .wim-poligon {
          display:none;
        }
        .wim-quote {
          width: 100%;;
          height: 100%;
          text-align: left;
          margin:0;
          &::before {
            display: none;
            transform: none;
            left:3%;
          }
        }
      }
    }
    .wim-video-container {
      width: 100%;
      margin: 0;
      padding: 0;
      padding-bottom: 56.25%;
      height: auto;

      video {
        width: 100%;
      }
    }
  }
}
@media(max-width: 767px) {
  .wim-quote-component {
    margin: 20px 10px;
    width: calc(100% - 20px);
  }
}
</style>